export default class {
  /**
   * @returns {{EMERGENCY: string, NOTICE: string, ERROR: string, ALERT: string, INFO: string, WARNING: string, DEBUG: string, CRITICAL: string}}
   */
  static levels() {
    return {
      EMERGENCY: "emergency",
      ALERT: "alert",
      CRITICAL: "critical",
      ERROR: "error",
      WARNING: "warning",
      NOTICE: "notice",
      INFO: "info",
      DEBUG: "debug"
    };
  }

  /**
   * @returns {(string)[]}
   */
  static bySeverity() {
    return [
      this.levels().EMERGENCY,
      this.levels().ALERT,
      this.levels().CRITICAL,
      this.levels().ERROR,
      this.levels().WARNING,
      this.levels().NOTICE,
      this.levels().INFO,
      this.levels().DEBUG
    ];
  }

  /**
   * @returns {string[]}
   */
  static bySeverityDesc() {
    return [...this.bySeverity()].reverse();
  }

  /**
   * @param {string} threshold
   * @param {boolean} includeThreshold
   * @returns {string[]}
   */
  static aboveSeverity(threshold, includeThreshold = false) {
    return this.beforeSeverity(this.bySeverity(), threshold, includeThreshold);
  }

  /**
   * @param {string} threshold
   * @param {boolean} includeThreshold
   * @returns {string[]}
   */
  static belowSeverity(threshold, includeThreshold = false) {
    return this.beforeSeverity(
      this.bySeverityDesc(),
      threshold,
      includeThreshold
    );
  }

  /**
   * @param {string[]} levels
   * @param {string} threshold
   * @param {boolean} includeThreshold
   */
  static beforeSeverity(levels, threshold, includeThreshold = false) {
    if (!levels.includes(threshold)) {
      throw "Unknown level: " + threshold;
    }

    let result = [];

    for (const level of levels) {
      result.push(level);
      if (level === threshold) {
        break;
      }
    }

    // if we should not include the threshold, we have to remove the last item (which is =threshold)
    if (!includeThreshold) {
      result.pop();
    }

    return result;
  }
}
